import React from 'react';
import Icon from '@/components/ui/AppIcon';

const badges = [
  { id: 'badge-warrior', name: 'Forge Warrior', icon: 'ShieldCheckIcon', theoEarned: true, tracyEarned: true, desc: '30 consecutive days' },
  { id: 'badge-protein', name: 'Protein Master', icon: 'FireIcon', theoEarned: true, tracyEarned: false, desc: '14 days hitting protein' },
  { id: 'badge-steps', name: 'Step Hunter', icon: 'BoltIcon', theoEarned: true, tracyEarned: true, desc: '10k steps 7 days straight' },
  { id: 'badge-discipline', name: 'Discipline Builder', icon: 'AcademicCapIcon', theoEarned: false, tracyEarned: true, desc: '21 clean eating days' },
  { id: 'badge-excuses', name: 'No Excuses', icon: 'NoSymbolIcon', theoEarned: true, tracyEarned: false, desc: '7 days, zero unplanned food' },
  { id: 'badge-weekend', name: 'Weekend Survivor', icon: 'SunIcon', theoEarned: true, tracyEarned: true, desc: 'Compliant both weekend days' },
  { id: 'badge-streak', name: 'Streak Guardian', icon: 'StarIcon', theoEarned: false, tracyEarned: false, desc: '60 day streak — locked' },
  { id: 'badge-second', name: 'No Second Bad Day', icon: 'ArrowPathIcon', theoEarned: true, tracyEarned: false, desc: 'Recovery after miss' },
];

export default function BadgeDisplay() {
  return (
    <div className="card-forge rounded-xl p-5">
      <div className="text-forge-label mb-4">Forge Badges</div>
      <div className="grid grid-cols-2 gap-3">
        {badges.map((badge) => {
          const anyEarned = badge.theoEarned || badge.tracyEarned;
          return (
            <div
              key={badge.id}
              className={`card-elevated rounded-lg p-3 border transition-all ${
                anyEarned ? 'border-border' : 'border-border/30 opacity-50'
              }`}
            >
              <div className="flex items-start gap-2">
                <div className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 ${anyEarned ? 'bg-primary/10' : 'bg-muted'}`}>
                  <Icon
                    name={badge.icon as Parameters<typeof Icon>[0]['name']}
                    size={16}
                    className={anyEarned ? 'text-primary' : 'text-muted-foreground'}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-xs font-bold text-foreground truncate">{badge.name}</div>
                  <div className="text-2xs text-muted-foreground">{badge.desc}</div>
                </div>
              </div>
              <div className="flex gap-2 mt-2">
                <span className={`text-2xs font-bold px-1.5 py-0.5 rounded ${badge.theoEarned ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'}`}>
                  T
                </span>
                <span className={`text-2xs font-bold px-1.5 py-0.5 rounded ${badge.tracyEarned ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
                  T
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}